import { useEffect, useState } from 'react';
import { FacilityImage } from '../../../types/facility';

export default function FacilityGallery() {
  const [facilities, setFacilities] = useState<FacilityImage[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const saved = localStorage.getItem('facilities');
    if (saved) {
      const loadedFacilities = JSON.parse(saved);
      setFacilities(loadedFacilities.sort((a: FacilityImage, b: FacilityImage) => a.order - b.order));
    } else {
      const defaultFacilities: FacilityImage[] = [
        {
          id: '1',
          name: '스튜디오 1 - 크로마키',
          imageUrl: 'https://public.readdy.ai/ai/img_res/9662e9f0ce1422e7886cd5d31e5372b9.jpg',
          order: 1
        },
        {
          id: '2',
          name: '스튜디오 2 - 전자칠판',
          imageUrl: 'https://readdy.ai/api/search-image?query=modern%20electronic%20whiteboard%20studio%20professional%20education%20recording%20facility%20clean%20white%20background%20interactive%20display%20minimalist%20aesthetic&width=1200&height=800&seq=facility2&orientation=landscape',
          order: 2
        },
        {
          id: '3',
          name: '대기 공간',
          imageUrl: 'https://readdy.ai/api/search-image?query=comfortable%20modern%20waiting%20lounge%20area%20professional%20studio%20facility%20clean%20minimalist%20design%20cozy%20seating%20natural%20lighting%20aesthetic&width=1200&height=800&seq=facility3&orientation=landscape',
          order: 3
        },
        {
          id: '4',
          name: '편집실',
          imageUrl: 'https://readdy.ai/api/search-image?query=professional%20video%20editing%20room%20modern%20workstation%20multiple%20monitors%20clean%20organized%20workspace%20minimalist%20professional%20aesthetic&width=1200&height=800&seq=facility4&orientation=landscape',
          order: 4
        },
        {
          id: '5',
          name: '스튜디오 5 - 대담형',
          imageUrl: 'https://readdy.ai/api/search-image?query=professional%20interview%20talk%20show%20studio%20modern%20broadcast%20facility%20comfortable%20seating%20clean%20minimalist%20design%20professional%20lighting%20aesthetic&width=1200&height=800&seq=facility5&orientation=landscape',
          order: 5
        }
      ];
      localStorage.setItem('facilities', JSON.stringify(defaultFacilities));
      setFacilities(defaultFacilities);
    }
  }, []);

  useEffect(() => {
    if (facilities.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % facilities.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [facilities.length]);

  if (facilities.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="w-full h-96 flex items-center justify-center bg-gray-100">
          <p className="text-gray-400">시설 이미지가 없습니다</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
      {/* Main Image Display */}
      <div className="relative w-full h-[600px] overflow-hidden">
        {facilities.map((facility, index) => (
          <div
            key={facility.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={facility.imageUrl}
              alt={facility.name}
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
              <h3 className="text-white text-2xl font-bold">{facility.name}</h3>
            </div>
          </div>
        ))}
      </div>

      {/* Thumbnail Navigation */}
      <div className="p-6 bg-gray-50">
        <div className="flex gap-4 justify-center overflow-x-auto">
          {facilities.map((facility, index) => (
            <button
              key={facility.id}
              onClick={() => setCurrentIndex(index)}
              className={`flex-shrink-0 relative group cursor-pointer transition-all duration-300 ${
                index === currentIndex ? 'ring-4 ring-secondary scale-110' : 'hover:scale-105'
              }`}
            >
              <div className="w-32 h-20 rounded-lg overflow-hidden">
                <img
                  src={facility.imageUrl}
                  alt={facility.name}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors rounded-lg flex items-end p-2">
                <span className="text-white text-xs font-medium truncate w-full">
                  {facility.name}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
